export enum UnitSelectionModeEnum {
  OPTIONAL = "OPTIONAL",
  MANDATORY = "MANDATORY",
}

export interface AccommodationConfig {
  enabled: boolean;
  chargeExtraTicker?: string;
}

export interface CampingMapDTO {
  unitSelectionMapConfiguration?: string;
}

export interface CampingMapEntity {
  id: string;
  enabled: boolean;
  baseUrl: string;
  selectionMode: UnitSelectionModeEnum;
  chargeSelection: boolean;
  selectionExpirationMinutes: number;
  accommodationConfig: Record<string, AccommodationConfig>;
}
